export enum CashierOpenMode {
    READ = "read",
    WRITE = "write",
}
